export default "__VITE_ASSET__DmV0rJgk__"